import { useEffect } from "react";

export function useNoindex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    meta.setAttribute("data-rmm-noindex", "true");
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
}
